import React from "react";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { Paths, Urls } from "./../constants/UrlConstants";
import { getPhone, getOpeningHours } from "../helpers/ContentStateHelper";

const HowToSeeWhoIsCovered = {
  Question: "How do I see who's covered?",
  Answer: {
    Any: (
      <React.Fragment>
        <p>
          If you're the lead member, you can view everyone who's covered under
          your plan on the Cover details page, under 'Other people on my plan'.
        </p>
        <p>
          For confidentiality, if you're a family member, you can only view the
          lead member's details.
        </p>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
          If you're the policyholder, you can view everyone who's covered under
          your policy on the Cover details page, under 'Other people on my
          policy'.
        </p>
        <p>
          For confidentiality, if you're a family member, you can only view the
          policyholder's details.
        </p>
      </React.Fragment>
    )
  }
};
const whoAreCovered = {
  Question: "Who are the people covered?",
  Answer: {
    Any: (
      <p>
        The people covered are the lead member and any family members who are
        covered by your membership and who share the same membership number.
      </p>
    ),
    HOL: (
      <p>
        The people covered are the policyholder and any family members who are
        covered by your membership and who share the same membership number.
      </p>
    )
  }
};

const HowDoIAddOtherOptions = {
  Question: "When and how can I make changes to my cover?",
  Answer: {
    Any: (props, params) => (
      <p>
        You can add options to your plan in the 14 days after you join us, or each year at your renewal once you’ve received your renewal documents.<br></br>
        <br></br>You can remove or reduce options or cancel your plan at any time during the year.<br></br>
        <br></br>To amend the options on your plan, we'll need to speak with you. <br></br><br></br>Please
        call us on <strong>{getPhone(props)}</strong>
        . Lines are open {getOpeningHours(props)}.
      </p>
    ),
    HOL: (props, params) => (
      <p>
        You can add options to your policy in the 14 days after you join us, or each year at your renewal once you’ve received your renewal documents.<br></br>
        <br></br>You can remove or reduce options or cancel your policy at any time during the year.<br></br>
        <br></br>To amend the options on your policy, we'll need to speak with you. <br></br><br></br>Please
        call us on <strong>{getPhone(props)}</strong>
        . Lines are open {getOpeningHours(props)}.
      </p>
    )
  }
};

export default {
  CoverDocumentsTitle: <h2>Membership documents</h2>,
  CoverDocumentsDescription: (
    <p>
      These documents provide information about your membership including full
      details of what you're covered for, what isn't covered and how to make a
      claim. Please enable pop-ups when viewing them on tablets and phones.
    </p>
  ),
  UnderwritingTitle: <h3>Underwriting guide</h3>,
  UnderwritingDescription: (
    <React.Fragment>
      <p>
        Your cover depends on the underwriting option your employer agreed with
        us, so it's really important that you understand what this means. We've
        put together this{" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.AxaHealthUnderwritingTerms}
          target="_blank"
          rel="noopener noreferrer"
        >
          quick guide
        </a>{" "}
        for you to look through.
      </p>
    </React.Fragment>
  ),
  PrivateHealthCareTitle: <h3>Private healthcare guide</h3>,
  PrivateHealthCareDescription: (
    <React.Fragment>
      <p>
        Not sure how your private healthcare plan works? This{" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.AxaPrivateHealthCareGuide}
          target="_blank"
          rel="noopener noreferrer"
        >
          handy guide
        </a>{" "}
        tells you everything you need to know.
      </p>
    </React.Fragment>
  ),
  MembershipStatementName: {
    Format2: "My membership certificate",
    Any: "My membership guide"
  },
  MembershipStatementDescription: {
    Any: "This provides details of your membership."
  },
  MembershipStatementMissing: {
    Any: (
      <p>
        Sorry, we're unable to display your membership guide at the moment.
        Please try again later. If you continue to experience problems, please
        call us.
      </p>
    ),
    Format2: (
      <p>
        Sorry, we're unable to display your membership certificate at the
        moment. Please try again later. If you continue to experience problems,
        please call us.
      </p>
    )
  },
  DependantMembershipStatementMessage: {
    Format2:
      "Due to medical confidentiality we are only allowed to provide the membership certificate to the lead member.",
    Any:
      "Due to medical confidentiality we are only allowed to provide the membership guide to the lead member."
  },
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    HelpSetForHarpa: [
      HowToSeeWhoIsCovered,
      whoAreCovered,
      HowDoIAddOtherOptions
    ],
    HelpSetForCrest: [whoAreCovered, HowDoIAddOtherOptions],
    HelpSetForSMEModular: [HowToSeeWhoIsCovered, whoAreCovered],
    HelpSetForLargeCorporate: [whoAreCovered]
  }
};
